module.exports = __webpack_public_path__ + "static/img/5.93c28735.png";